<template>
  <div class="id-cell">
    <router-link
      :to="'/' + link + '/' + model"
      class="id-cell__link"
      title="Detaya git"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="w-6 h-8"
        viewBox="0 0 24 24"
      >
        <path
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="M12.25 12h-.5m.5-4h-.5m.5 8h-.5"
        />
      </svg>
    </router-link>
    <button
      v-if="quickView"
      type="button"
      class="id-cell__quick"
      title="Lead kartını yanda aç"
      @click.prevent.stop="openQuickView()"
    >
      <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" viewBox="0 0 24 24">
        <path
          fill="currentColor"
          d="M5 21q-.825 0-1.412-.587T3 19V5q0-.825.588-1.412T5 3h14q.825 0 1.413.588T21 5v14q0 .825-.587 1.413T19 21zm10-2h4V5h-4zm-2 0V5H5v14zm2 0h4z"
        />
      </svg>
    </button>
  </div>
</template>

<script>
import EventBus from "../EventBus";

export default {
  name: "id",
  // Liste (Table.vue) sağlıyorsa drawer'da önceki/sonraki ve sayfa geçişi için
  inject: {
    leadQuickViewSource: { default: null },
  },
  data() {
    return {
      link: "edit/" + this.input.table,
      model: null
    };
  },
  props: ["input", "form", "rowdata", "rowall"],
  computed: {
    quickView() {
      return this.link === "leadDetail";
    }
  },
  created() {
    this.model = this.rowdata;
    if (this.input.options) {
      this.link = this.input.options;
    }
  },
  methods: {
    openQuickView() {
      const source = this.leadQuickViewSource;
      EventBus.$emit("leadQuickViewOpen", {
        id: this.model,
        ids: source ? source.ids() : [this.model],
        source
      });
    }
  },
  watch: {
    form() {
      if (this.form) {
        this.model = null;
      }
    },
    model() {
      this.$parent.$emit("change", {
        name: this.input.name,
        value: this.model
      });
    }
  }
};
</script>

<style>
.id-cell {
  @apply flex items-center justify-center;
}

.id-cell__link {
  @apply text-gray-400;
}

.id-cell__link:hover {
  @apply text-tile-500;
}

.id-cell__quick {
  @apply inline-flex items-center justify-center w-6 h-6 rounded-md text-gray-400 bg-transparent border-0 cursor-pointer;
}

.id-cell__quick:hover {
  @apply bg-tile-50 text-tile-500;
}
</style>
